/**
 * トップページ（`/`）の静的な部分。
 *
 * 公開中の診断は API（`GET /v1/themes`）から取る（運営が用意した診断＋みんなが作った診断、受けた回数順）。
 * ここにあるのは「自分で作る」欄の書き方の例。
 */
export interface PlannedTheme {
  readonly id: string;
  readonly title: string;
  readonly catch: string;
  /** 押すと「自分で作る」欄に入るプロンプト。 */
  readonly prompt: string;
  readonly emoji: string;
}

/** こんな診断が作れる、という種。押すとプロンプト欄に入る。 */
export const PLANNED_THEMES: readonly PlannedTheme[] = [
  { id: 'mukashi', title: '日本むかし話診断', emoji: '🍑', catch: '桃太郎か浦島太郎か、それともお供の犬か。脇役やものまで登場。', prompt: '日本むかし話診断。桃太郎・浦島太郎・金太郎・犬・猿・雉・かぐや姫・鬼など、主役だけでなく脇役やものも登場人物にする。' },
  { id: 'kissaten', title: '喫茶店メニュー診断', emoji: '☕', catch: 'あなたをメニューにたとえると。ブレンドか、ナポリタンか、クリームソーダか。', prompt: '喫茶店のメニューにたとえる診断。大学生がシェアして遊べる軽さで。' },
  { id: 'meijo', title: '日本の名城診断', emoji: '🏯', catch: '守りの堅い山城か、人が集う平城か。あなたを城にたとえると。', prompt: '日本の名城。山城・平城・水城など立地や築城の考え方の違いを性格になぞらえる診断。旅行好きの若者向け。' },
  { id: 'shinkai', title: '深海生物診断', emoji: '🦑', catch: '光の届かない場所で、それぞれのやり方で生きる。あなたに似た深海のいきもの。', prompt: '深海生物。ダイオウイカやチョウチンアンコウなど、それぞれの生き残り戦略を性格の傾向に結びつける診断。' },
];

/** 「自分で作る」欄の書き方の例。押すとそのまま入る。 */
export const PROMPT_EXAMPLES: readonly string[] = [
  '日本むかし話診断',
  '宇宙探査クルーの役割診断。チームで働くときの持ち味が分かるように。',
  '地元の名物や行事をキャラにした診断。',
];

export const PROMPT_MAX = 400;

/** キャラ（タイプ）の数。診断の軸は 2 のべき乗にしか分けられないので、選べるのはこの 5 つ。既定は 16。 */
export const TYPE_COUNTS: readonly number[] = [4, 8, 16, 32, 64];
export const DEFAULT_TYPE_COUNT = 16;
/** 入力欄に自由な数を入れたときに、選べる数へ丸める（対数の目盛りでいちばん近いもの。サーバと同じ規則）。 */
export function roundTypeCount(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_TYPE_COUNT;
  const min = TYPE_COUNTS[0];
  const max = TYPE_COUNTS[TYPE_COUNTS.length - 1];
  if (value <= min) return min;
  if (value >= max) return max;
  const target = Math.log2(value);
  return TYPE_COUNTS.reduce((best, c) => (Math.abs(Math.log2(c) - target) < Math.abs(Math.log2(best) - target) ? c : best), min);
}
